import { useContext } from 'react';
import { Box, Snackbar, useTheme } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorIcon from '@mui/icons-material/Error';

import { ToastContext } from '../../globalContext/toast/toastProvider';
import { hideToast } from '../../globalContext/toast/toastActions';
import { TOAST_DURATION } from '../../consts/constants';

const Toast = () => {
  const [toastInfo, dispatchToastInfo] = useContext(ToastContext);
  const theme = useTheme();

  return (
    <Snackbar
      open={toastInfo?.isVisible ?? false}
      autoHideDuration={toastInfo?.duration ?? TOAST_DURATION}
      message={
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: theme.custom.gap.small,
          }}
        >
          {toastInfo?.type === 'success' ? (
            <CheckCircleOutlineIcon />
          ) : (
            <ErrorIcon />
          )}
          <span>{toastInfo?.message}</span>
        </Box>
      }
      anchorOrigin={{
        vertical: toastInfo?.verticalPos ?? 'top',
        horizontal: toastInfo?.horizontalPos ?? 'right',
      }}
      ContentProps={{
        sx: {
          backgroundColor:
            toastInfo?.type === 'success'
              ? theme.palette.tertiary?.green
              : theme.palette.quinary?.main,
          color: theme.palette.text.elevenary,
          fontWeight: theme.typography.fontWeight.normal,
        },
      }}
      onClose={() => {
        dispatchToastInfo(hideToast());
      }}
    />
  );
};

export default Toast;
